(ns frontend.view.reports.custom.alj-2.deals-approved-charts
  (:require
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn pie-deals-presented-to-CIC-chart-data
  [approved-oppos]
  (let [used-deal-types (->> approved-oppos
                             (mapcat :oppo/tag-deal-type)
                             (set))

        data
        (->> used-deal-types
             (map (fn [deal-type]
                    (let [deals (->> approved-oppos
                                     (filter (fn [oppo]
                                               (let [deal-type-tags (:oppo/tag-deal-type oppo)]
                                                 (and deal-type-tags
                                                      (some #{deal-type} deal-type-tags))))))
                          label (fu/resolve-name deal-type)
                          ticket-size-sum (alj-utils/ticket-size-sum-millions deals)]
                      {:name label
                       :y    (count deals)
                       :ticketSizeSum ticket-size-sum})))
             (sort-by :y)
             (reverse)
             (vec))
        deals-by-type (->> approved-oppos
                           (group-by :oppo/tag-deal-type))]
    {:series [{:name         (loc/tr :oppo/tag-deal-type)
               :colorByPoint true
               :data         data}]}))


(defn pie-chart
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [approved-oppos (->> (alj/all-deals)
                                (filter (fn [oppo]
                                          (some->> oppo
                                                   :oppo/CIC-recommendation
                                                   (get @session/entities)
                                                   :named-value/value
                                                   (= "Approved"))))
                                (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                                (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                                (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))

            ;oppos (alj-utils/deals-in-date-range :oppo/date-CIC-presentation date-state-atom approved-oppos)

            chart-data (pie-deals-presented-to-CIC-chart-data approved-oppos)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [label y]}]
                                    [label y]))
                             (doall))
            view-name "Total IAC approved deals by deal type"]
        [alj-components/alj-pie-chart-v2
         {:view-name       view-name
          :total-deals     (count approved-oppos)
          :total-amount    (alj-utils/ticket-size-sum-billions approved-oppos)
          :report-data     export-data
          :date-state-atom date-state-atom
          :chart-data      chart-data}]))))
